/**
 * @typedef {typeof import ('./state').default} State
 * @typedef {import ('./state').Notification} Notification
 *
 * @typedef {Object} NotificationMutationPayloads
 * @property {boolean} setIsLoading
 * @property {Notification[]} setNotifications
 * @property {Notification} addOne
 * @property {boolean} setIsListOpen
 * @property {'unread' | 'all'} setMode
 * @property {number} setTotal
 * @property {boolean} setHasMore
 * @property {number} setUnread
 * @property {void} incUnread
 * @property {void} decUnread
 *
 * @typedef {{[K in keyof NotificationMutationPayloads]: (state: State, payload: NotificationMutationPayloads[K]) => void}} NotificationMutations
 */

/**
 * @type {NotificationMutations}
 */
export default {
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setNotifications(state, notifications) {
    state.notifications = notifications
  },
  addOne(state, notification) {
    state.notifications.push(notification)
    state.total++
  },
  setIsListOpen(state, isOpen) {
    state.isListOpen = isOpen
  },
  setMode(state, mode) {
    state.mode = mode
  },
  setTotal(state, total) {
    state.total = total
  },
  setHasMore(state, hasMore) {
    state.hasMore = hasMore
  },
  setUnread(state, nUnread) {
    state.nUnread = nUnread
  },
  incUnread(state) {
    state.nUnread++
  },
  decUnread(state) {
    state.nUnread--
  },
}
